<template>
  <v-container>
    <div class="main-wrapper">
      <div>
        <h3>{{ text.ravintoloille.mainHeader }}</h3>
        <p>{{ text.ravintoloille.mainStory }}</p>
      </div>

      <v-spacer></v-spacer>
      <router-link to="/"> Takaisin etusivulle </router-link>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "About",
  props: ["text"],
};
</script>




<style scoped>
h3 {
  font-size: 1.75rem;
  margin-bottom: 0.5rem;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.2;
  color: inherit;
}

.main-wrapper {
  margin-bottom: 2%;
  margin-left: 5%;
  margin-right: 5%;
}

.v-application a {
  color: blue;
  text-decoration: none;
}
</style>>